module.exports = __webpack_public_path__ + "static/media/logo-juntos.03f4d79e.svg";